var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreadCrumbsRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1640_7383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02924 0.220115C0.882334 0.361098 0.799805 0.552285 0.799805 0.751634C0.799805 0.950983 0.882334 1.14217 1.02924 1.28315L4.90826 5.00454L1.02924 8.72592C0.886498 8.86771 0.807511 9.05762 0.809296 9.25474C0.811082 9.45186 0.893497 9.64042 1.03879 9.77981C1.18408 9.91919 1.38063 9.99826 1.5861 9.99997C1.79157 10.0017 1.98951 9.92591 2.13731 9.78896L6.57036 5.53606C6.71727 5.39508 6.7998 5.20389 6.7998 5.00454C6.7998 4.80519 6.71727 4.614 6.57036 4.47302L2.13731 0.220115C1.99035 0.0791756 1.79107 0 1.58328 0C1.37548 0 1.1762 0.0791756 1.02924 0.220115Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1640_7383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 10,
    fill: "white",
    transform: "translate(0.799805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadCrumbsRightArrow);
export default __webpack_public_path__ + "static/media/bread_crumbs_right_arrow.318476a3c88766e7ce4af3c8d2d67e4f.svg";
export { ForwardRef as ReactComponent };